/* eslint-disable import/prefer-default-export */
import { IEmptyState } from 'app/interfaces/empty-state/empty-state.interface';
import ImagePath from 'app/utilities/imagePath';

export const nonRDLEmptyState: IEmptyState = {
	image: ImagePath.noData,
	placeholder: "Oops, virtual account Anda masih diproses",
	caption: "Ketika nomor virtual account Anda sudah berhasil diproses, instruksi deposit akan tampil."
};
